import { defineStore } from "pinia";
import { ref, computed } from "vue";
import website from "@/const/website";
import { useTagsStore } from "./tags";
import { login as loginApi, getUserInfo } from "@/api/login";
import { encryption, generateSign } from "@/utils/util";

// localStorage 存储键名，统一使用 website.key 作为前缀
const STORAGE_KEYS = {
  TOKEN: `${website.key}_token`,
  USER_INFO: `${website.key}_userInfo`,
};

export const useUserStore = defineStore("user", () => {
  // 状态
  const token = ref<string>(localStorage.getItem(STORAGE_KEYS.TOKEN) || "");
  const userInfo = ref<any>(null);

  // 计算属性
  const isLoggedIn = computed(() => !!token.value);
  const username = computed(() => userInfo.value?.username || "");

  /**
   * 登录流程：加密 → 调用登录接口 → 存储 token → 获取用户信息 → 存储 userInfo
   */
  async function loginAction(loginForm: {
    username: string;
    password: string;
  }) {
    // 1. 密码 AES 加密
    const user = encryption({
      data: { username: loginForm.username, password: loginForm.password },
      key: "pigxpigxpigxpigx",
      param: ["password"],
    });
    const params = {
      password: user.password,
      username: user.username,
      operation_backend_pc: "supplier_platform_pc",
    };
    // 2. MD5 生成 sign
    const sign = generateSign(params, "（6.9.8）xyd20191023");
    (params as any).sign = sign;

    // 3. 调用登录接口
    const randomStr = "blockPuzzle";
    const res = await loginApi(params as any, "", randomStr);
    console.log("res-------------", res);

    // 4. 存储 token
    token.value = res.access_token;
    localStorage.setItem(STORAGE_KEYS.TOKEN, res.access_token);
    localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(res.user_info));
    // 登录后重置标签卡
    useTagsStore().resetTags();
  }

  // 退出登录
  function logout() {
    token.value = "";
    userInfo.value = null;
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER_INFO);
  }

  /**
   * 获取当前用户信息并存储
   */
  async function getUser() {
    const res = await getUserInfo({ sourceType: "S" });
    const data = res.data || {};
    const info = Object.assign(data.sysUser, {
      firstLogin: data.firstLogin,
      supplierCode: data.supplierCode,
    });
    userInfo.value = info;
    localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(info));
  }

  // 初始化用户信息（从本地存储恢复）
  function initUserInfo() {
    const stored = localStorage.getItem(STORAGE_KEYS.USER_INFO);
    if (stored) {
      try {
        userInfo.value = JSON.parse(stored);
      } catch {
        userInfo.value = null;
      }
    }
  }

  return {
    token,
    userInfo,
    isLoggedIn,
    username,
    loginAction,
    logout,
    getUser,
    initUserInfo,
  };
});
